import { PlainColumn } from 'app/common/ui/PlainGrid'
import { SummaryRow } from 'app/components/common/reports/summary'
import { TotalEncashmentsSummaryType } from 'app/dataTypes/reports/data'
import SummaryItem from './summary-item'


type Props = {
  totalSummaryData: TotalEncashmentsSummaryType
  currency: string
  loading?: boolean
}

export const Summary = ({ totalSummaryData, currency, loading }: Props) => {
  return (
    <PlainColumn>
      <SummaryRow baseline={false}>
        <PlainColumn>
          <SummaryItem
            key="BalanceAtTheBeginning"
            title="Остаток на начало дня"
            value={`${totalSummaryData.balanceAtTheBeginning} ${currency}`}
            pending={loading}
          />
        </PlainColumn>
        <PlainColumn >
          <SummaryItem
            key="Revenue"
            title="Выручка"
            value={`${totalSummaryData.revenue} ${currency}`}
            pending={loading}
          />
          <SummaryItem
            key="Collected"
            title="Сдано"
            value={`${totalSummaryData.collected} ${currency}`}
            pending={loading}
          />
        </PlainColumn>
        <PlainColumn >
          <SummaryItem
            key="BalanceAtTheEnd"
            title="Остаток на конец дня"
            value={`${totalSummaryData.balanceAtTheEnd} ${currency}`}
            pending={loading}
          />
        </PlainColumn>
      </SummaryRow>
      <SummaryRow baseline={false}>
        <SummaryItem
          key="WaitingForCash"
          title="ОЖИДАЕТ"
          value={`${totalSummaryData.statuses.waitingForCash} ${currency}`}
          pending={loading}
          valueColor='waiting'
        />
        <SummaryItem
          key="CashAccepted"
          title="ПРИНЯТО"
          value={`${totalSummaryData.statuses.cashAccepted} ${currency}`}
          pending={loading}
          valueColor='accepted'
        />
        <SummaryItem
          key="CashRefused"
          title="ОТКАЗАНО"
          value={`${totalSummaryData.statuses.cashRefused} ${currency}`}
          pending={loading}
          valueColor='refused'
        />
        {/* <SummaryItem
          key="cashNotDeposited"
          title="НЕ СДАНО"
          value={`${totalSummaryData.statuses.cashNotDeposited} ${currency}`}
          pending={loading}
        /> */}
      </SummaryRow>
    </PlainColumn>
  )
}
